import {
  DropdownButton,
  SelectionList,
  SelectionListChangeEvent,
} from '@dixa/lib-shared-habla';
import type {
  SearchFilters,
  SearchFilterValue,
  SearchFilterValueString,
} from 'lib-search-types';
import { memo, useCallback, useMemo, useState } from 'react';

import { userTypeAssets } from 'utils/user';

import { ConditionFieldLayout } from 'app/views/layout/views/search/components/filters/components/condition/components/field/components/layout/conditionFieldLayout';

type ContactsFilterUserTypeProps = {
  filters: SearchFilters<'users'>;
  onChangeFilters: (filters: SearchFilters<'users'>) => void;
};

export const ContactsFilterUserType = memo(function ContactsFilterUserType({
  filters,
  onChangeFilters,
}: ContactsFilterUserTypeProps): JSX.Element {
  const [isOpen, setIsOpen] = useState(false);

  const condition = useMemo(
    () =>
      filters.filters
        .filter((filter) => 'field' in filter)
        .find((filter) => filter.field === 'user_type'),
    [filters.filters],
  );

  const handleChange = useCallback(
    ({ selectedValues }: SelectionListChangeEvent<SearchFilterValue>) => {
      const otherFilters = filters.filters.filter(
        (filter) => 'field' in filter && filter.field !== 'user_type',
      );

      onChangeFilters({
        ...filters,
        filters:
          selectedValues.length > 0
            ? [
                ...otherFilters,
                {
                  field: 'user_type',
                  operator: 'is_one',
                  values: selectedValues as SearchFilterValueString[],
                },
              ]
            : otherFilters,
      });
    },
    [filters, onChangeFilters],
  );

  return (
    <DropdownButton
      show={isOpen}
      onToggle={setIsOpen}
      buttonProps={{
        variant: 'tertiary',
        label: condition?.values?.length || undefined,
      }}
      fixed
      dropdown={
        <ConditionFieldLayout>
          <ConditionFieldLayout.Row noPadding>
            <SelectionList
              isMultiple
              isActive={isOpen}
              selectedValues={condition?.values ?? []}
              onChange={handleChange}
              equalityFn={(a, b) => a.value === b.value}
              defaultActiveItemIndex={0}
            >
              {Object.entries(userTypeAssets)
                .filter(([id]) => id !== 'bot')
                .map(([id, { prettyName }]) => (
                  <ConditionFieldLayout.Item
                    key={id}
                    value={{ value: id }}
                    label={prettyName}
                  />
                ))}
            </SelectionList>
          </ConditionFieldLayout.Row>
        </ConditionFieldLayout>
      }
    >
      Category
    </DropdownButton>
  );
});
